@if (loading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ loadingText }}
  </mat-label>
</div>
}
<div class="as-add-card-container">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>

  <mat-label class="as-roboto-slab as-font-bold as-font-24">
    @if (!isUpdate) {
    {{ 'CLUB.activateCardHeader' | translate }}
    }@else{
    {{ 'CLUB.updateCardHeader' | translate }}
    }
  </mat-label>
  <ng-container>
    <form autocomplete="off" class="as-card-number-form" [formGroup]="clubForm">
      <mat-form-field appearance="outline" color="accent" class="as-font">
        <mat-label> {{ 'PURCHASE.numberCardDigits' | translate }} </mat-label>
        <input
          placeholder="{{ 'CLUB.typecard' | translate }}"
          matInput
          formControlName="clubCardID"
          mask="0 00000 00000 0"
          maxlength="15"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent" class="as-font">
        <mat-label>
          {{ 'PURCHASE.phoneNumberAssociate' | translate }}
        </mat-label>
        <input
          placeholder="{{ 'CLUB.typePhone' | translate }}"
          matInput
          formControlName="phone"
          maxlength="13"
          mask="000-000-00-00"
        />
      </mat-form-field>
      @if (showClubVerifyError) {
      <mat-error>
        {{ 'CLUB.notSameNumber' | translate }}
      </mat-error>
      }

      <div class="as-row as-gap-10 as-align-center as-info-blue">
        <mat-icon svgIcon="ic-information-blue"></mat-icon>
        <p class="as-font-black-gray as-font as-font-14 as-font-normal">
          {{ 'CLUB.numberValidate' | translate }}
        </p>
      </div>

      <div
        class="as-row as-align-center as-gap-15 as-justify-sb as-buttons-container"
      >
        <button
          mat-stroked-button
          mat-dialog-close
          class="green"
          color="accent"
        >
          <mat-label class="as-font-16 as-font-semibold">
            {{ 'GENERAL.cancel' | translate }}
          </mat-label>
        </button>
        <button
          mat-flat-button
          color="accent"
          [disabled]="!clubForm.valid"
          (click)="onValidateClubInfo()"
        >
          <mat-label class="as-font-16 as-font-semibold as-font-white">
            {{ 'GENERAL.continue' | translate }}
          </mat-label>
        </button>
      </div>
    </form>
  </ng-container>
</div>
